import { type PreparationProcessType } from '@/common/types/preparation-process.type';

interface PreparationProcess {
  persianPraparationProcess: Record<PreparationProcessType, string>;
}
export const persianPreparationProcessConstant: PreparationProcess['persianPraparationProcess'] =
  {
    PENDING: 'در انتظار تایید',
    PROCESSING: 'در حال آماده سازی',
    SHIPPED: 'پایان یافته',
    REJECTED: 'رد شده',
    REJECTEDBYADMIN: 'رد شده توسط ادمین',
    AUTOREJECTED: 'لغو سیستمی',
    CANCELLED: 'لغو شده',
    CANCELLEDBYADMIN: 'لغو شده توسط ادمین',
    CANCELLEDBYVENDOR: 'لغو شده توسط فروشنده',
  };
